var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03739 11.2933C8.23887 8.59139 12.3742 6.81015 14.4433 5.94954C20.351 3.49232 21.5786 3.06547 22.3787 3.05138C22.5546 3.04828 22.9481 3.09189 23.203 3.2987C23.4182 3.47333 23.4774 3.70923 23.5058 3.8748C23.5341 4.04037 23.5694 4.41753 23.5413 4.71224C23.2212 8.07599 21.8359 16.2389 21.1312 20.0064C20.833 21.6005 20.2458 22.135 19.6774 22.1873C18.442 22.301 17.504 21.3709 16.3075 20.5866C14.4352 19.3593 13.3774 18.5953 11.5601 17.3977C9.45976 16.0136 10.8213 15.2529 12.0183 14.0097C12.3315 13.6843 17.7745 8.73349 17.8799 8.28437C17.893 8.2282 17.9053 8.01883 17.7809 7.90827C17.6565 7.79771 17.4729 7.83552 17.3404 7.86559C17.1527 7.90821 14.1616 9.88515 8.3674 13.7964C7.51841 14.3794 6.74943 14.6634 6.06044 14.6486C5.30089 14.6322 3.83981 14.2191 2.75365 13.866C1.42144 13.433 0.362616 13.204 0.454816 12.4686C0.502839 12.0855 1.03036 11.6937 2.03739 11.2933Z",
    fill: "url(#paint0_linear_3711_21237)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3711_21237",
    x1: 12.0004,
    y1: 3.05123,
    x2: 12.0004,
    y2: 22.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.2fcd13d4e496d316c6c405d0e52f2bd6.svg";
export { ForwardRef as ReactComponent };